(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[89193],{

/***/ 28946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: " Welcome",
    description: "We are pleased to announce our Tradly Platform knowledge portal which includes everything from documentation to detailed recipes on how to build a platform business. ",
    date: "2020-07-15T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-07-15-welcome";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are pleased to announce our Tradly Platform knowledge portal which includes everything from documentation to detailed recipes on how to build a platform business. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are starting small with information what we believe is needed for customers to start ahead. However, we will be regularly every week updating the contents to reflect new product updates and contents for our customers to be updated on what we are upto. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "WE are 100% sure this knowledge portal may not be perfect thing but we want to start small and continue build things on top of it. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Primary objectives of this platform "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Providing detailed documentation on features provided by Tradly Platform"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Step by step information on building different platform business model - Targeting one modal explanation every 10days"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Not as Primary source of API-Reference but as a secondary reference"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Superadmin Panel - How to guides "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Marketplace extentions - Integrations guides "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "FAQ, Other doubts. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Keep your ideas coming if there is anything missing on this portal"));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 29591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: " August Product Updates",
    description: "Thanks for being a great support to us and early adopters to help the product. \nYour ideas, your dreams and our vision are what drive us to innovate more and deliver new features.  ",
    date: "2020-09-12T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-09-12-augustupdate";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Hello All,"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Thanks for being a great support to us and early adopters to help the product.\nYour ideas, your dreams and our vision are what drive us to innovate more and deliver new features. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are sharing here what’s happening recently.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Managing revenue model from SuperAdmin Panel"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", {
        parentName: "p"
    }), "\n", "We have released a commission model configuration which allows platform owners to set commission on product category level. Previously, it was available on overall transactions. ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/docs/revenuemodel",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Further info")))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "New Notification center"), " ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", null), "\nAdding to our existing chat notifications, now you can find the permanent notification on the notification center about the order status and social feed.  ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Improved order detail page")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({
        parentName: "li"
    }, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Your buyers can directly chat with the seller.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Able to change the order status and confirm order delivery.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "And find the order status in detailed steps.\xa0"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Reviews")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({
        parentName: "li"
    }, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Your buyers can submit reviews with photos and ratings."))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Other things")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({
        parentName: "li"
    }, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Design Kit: We have made our design kit open for our customers to test different thematic colors and UI customisation. Available ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/docs/appcustomisation#app-primary-color",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "here"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Updated our docs on the customisation to explain clearly what you can change and what you cannot\xa0before launching the app to Playstore and Appstore. Also their specifications of assets")))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "li"
    }, "Star ⭐️ of the month"), " ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", null), "\nOur customer from Australia wanted to connect plant \uD83C\uDF31 loving communities. They are launching a marketplace using our infrastructure to allow people to buy and sell plants. We are excited about their idea and doing our best to succeed in their business.\xa0Posting here the app link in our next update for you to check if you are from australia. ")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 70107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "September Update",
    description: "As always thanks for the support and for sharing about our product to others. We are doing great and we believe you as well \uD83D\uDE0A.\xa0",
    date: "2020-10-14T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-10-14-productupdate";
var tableOfContents = [
    {
        "title": "About the Pitch",
        "slug": "about-the-pitch",
        "children": []
    },
    {
        "title": "Features Updates",
        "slug": "features-updates",
        "children": []
    },
    {
        "title": "Youtube Channel",
        "slug": "youtube-channel",
        "children": []
    },
    {
        "title": "New pricing for Developers",
        "slug": "new-pricing-for-developers",
        "children": []
    },
    {
        "title": "Opensourcing Hummingbird",
        "slug": "opensourcing-hummingbird",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As always thanks for the support and for sharing about our product to others. We are doing great and we believe you as well \uD83D\uDE0A.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Tradly made it to the semi finals in a pitch battle \uD83C\uDFC5. The great thing is our very fitch pitch is to one of the best VC in the world, Sequoia Capital \uD83D\uDE0E."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Features updates"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "New YouTube channel with multiple demo of our products"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "New Pricing for developer community with our API focused headless solution"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Open sourcing our react web app, Hummingbird")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "about-the-pitch",
        nextElement: {
            "type": "paragraph"
        }
    }, "About the Pitch"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "It doesn’t matter whether we win to the final! Considering as an early stage company(1year old) without big numbers like others, We are among the 6 innovative players who are selected. Our first goal is to get the brand exposure and get good suggestions from smart people, so we can innovate incredible products to our customers.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are thankful to Techinasia for organising and Sequoia Surge team for screening us to the semifinal!"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "features-updates",
        nextElement: {
            "type": "paragraph"
        }
    }, "Features Updates"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "On the app level and API level"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Now sellers can see the transactions from the buyers on mobile app itself")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Sellers able to see their sales balance and payment status to their bank account.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "New pickup flow: Seller can select their preferred shipment method")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Buyer can also select their preferred shipment method based on availability.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Seller can add additional shipping price while submitting listings")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Seller can add maximum quantity that buyer can purchase per listing.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/payout.jpg",
        alt: "payout",
        width: "300"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/shipment_method.jpg",
        alt: "shipment",
        width: "300"
    }))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "youtube-channel",
        nextElement: {
            "type": "paragraph"
        }
    }, "Youtube Channel"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We were bit delayed in the space of demonstrating our products in a clear way. We believe our initiative of making more videos can give more clarity and deeper view on how our solution works.\nWe are planning to add the channel with more videos on other topics like"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Platform Economy"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Building and Growing a Marketplace"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Do subscribe > ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://www.youtube.com/channel/UCRpXlfFBX5nayubY70-IFEA/"
    }), "Tradly Youtube"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "new-pricing-for-developers",
        nextElement: {
            "type": "paragraph"
        }
    }, "New pricing for Developers"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "From the day one our goal is to build an API first solution for the digital commerce revolution. It’s going to take long time to fulfil that goal. However, We are having a good start"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Whereby we have our headless API first version released with FREE ACCOUNT account"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "API in postman collection as of now"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Production environment starts just at $99.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "opensourcing-hummingbird",
        nextElement: {
            "type": "paragraph"
        }
    }, "Opensourcing Hummingbird"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are working on open sourcing our hummingbird, ReactJS web app that is connected with our API. Benefits are"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Developers can launch this on their own server like other ReactJS and own the production"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "This can serve as a good boilerplate instead of building something on their own. Fast to the market."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "In a month, we are planning to release the V1. If you would like to contribute, let us know.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "That’s all what we have. Let us know if there is any feedbacks. Again hope you are doing good \uD83D\uDE0A"));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 91899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "2020Q4 Product Updates",
    description: "Listening to wonderful entrepreneurs out is one of the happiest moment we have every day. We listen to their feedbacks, their plans, doubts, etc. We are working towards solving each goal aggressively \uD83D\uDE0E\xa0",
    date: "2020-12-01T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-12-01-productupdate";
var tableOfContents = [
    {
        "title": "Improved store profile pages",
        "slug": "improved-store-profile-pages",
        "children": []
    },
    {
        "title": "Store reviews",
        "slug": "store-reviews",
        "children": []
    },
    {
        "title": "Promo Banner Enhancement",
        "slug": "promo-banner-enhancement",
        "children": []
    },
    {
        "title": "API Status Tracking\xa0",
        "slug": "api-status-tracking",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Listening to wonderful entrepreneurs out is one of the happiest moment we have every day. We listen to their feedbacks, their plans, doubts, etc. We are working towards solving each goal aggressively \uD83D\uDE0E"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "\xa0\nThe last quarter of 2020 was a promising one which gave us signal on what’s working, what’s not and what need to be enhanced as well. This is achieved through two level of performance tracking. We improved our sentry implementation to identify different logs in front end apps and same way identifying issues in our backend API/database performance. Other than that dozen of feature releases to activate!\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Improved store profile pages to increase engagement between your seller and buyer \uD83D\uDC69‍\uD83C\uDFA8"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Store reviews is live ⭐️"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Promo banner enhancement \uD83C\uDFD9"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "API Status \uD83D\uDCB9"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Stability improvements through advanced log collection"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Slack Community Channel \uD83D\uDCAC")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "improved-store-profile-pages",
        nextElement: {
            "type": "paragraph"
        }
    }, "Improved store profile pages"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "The purpose behind to enhance this profile is to increase visibility of users and allow them to engage"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "“About us” section can provide more informations about a store."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Marketplace operators can add additional fields on account/store creation to increase the trust of buyers about a seller"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Direct chat : Allowing a chat directly from a store leads your users to contact sellers. A new chat means new engagement thus increasing the user retention by keep visiting the app"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Share button: Now the share button is more visible. Which will allow organic share of a certain stores by the users thus increasing new users"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Store Active and Inactive: Your sellers can now make a store active or inactive based on their business hours, vacation time or even they want to shut down for a while. This way your store operators can enjoy DND and also you can avoid sellers being churned"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Reviews and Ratings explicitly show on store profiles")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "store-reviews",
        nextElement: {
            "type": "paragraph"
        }
    }, "Store reviews"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Your users can submit reviews of a seller stores/orders, etc."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Your users can submit reviews of a store with details and photo of their experience\nComing soon:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Marketplace operators able to see the reviews in SuperAdmin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Marketplace operators able to see the details of a store Id with review scroll. Thus using the store ID, they can create custom collection widget on app home pages.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "promo-banner-enhancement",
        nextElement: {
            "type": "paragraph"
        }
    }, "Promo Banner Enhancement"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Adding to the existing way of have promo banner as static and listing as destination. Now"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can use external URL as a destination (Example: sending them to a FAQ Page)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can use store ID as a destination. This helps you to promote a particular store. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "api-status-tracking",
        nextElement: {
            "type": "paragraph"
        }
    }, "API Status Tracking\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Now you can track our servers reliability if you are in doubt about the performance of API."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "This status tracker provides if there is any issues in our API reliability, performance, etc"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can subscribe to the status tracker if you want to get update about maintenance updates, etc")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Link:\xa0", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "http://tradly.freshstatus.io/"
    }), "http://tradly.freshstatus.io/")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "\xa0\nThis is what we have on production and dozens of other product developments are happening in our TradlyPlatform ecosystem. One of the drastic improvement we are making is improving our SuperAdmin Panel. Stay Tuned! "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "You can test this features using sandbox apps with tenantID like ‘tradlysocial’ or ‘luxuryfashion’"));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 24009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "January Product Updates",
    description: "\nThanks for being great support to us with patience and feedbacks to improve the ecosystem. Every suggestions you give us always help your fellow entreprenuers as well.\xa0",
    date: "2021-01-18T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-01-18-january";
var tableOfContents = [
    {
        "title": "Account Approval",
        "slug": "account-approval",
        "children": []
    },
    {
        "title": "Attribute Enhancement",
        "slug": "attribute-enhancement",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Thanks for being great support to us with patience and feedbacks to improve the ecosystem. Every suggestions you give us always help your fellow entreprenuers as well. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Here is update for January so far:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Attributes enhancement (public-private, file attachment attribute)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Account Approval is live on production")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Note: If you want to activate this feature, let us know on slack for now. We will add this into SuperAdmin settings soon. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "account-approval",
        nextElement: {
            "type": "paragraph"
        }
    }, "Account Approval"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As a marketplace operators, you will be able to do a KYC process before approving stores to be shown in the marketplace. A bigger marketplace wants to regulate everything happening in it’s business"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Marketplace owner able to approve a store in superadmin panel similar to our existing listing approval"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can activate auto approval or manual approval based on your performance"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Until the store is activated, a seller account will not be visible in the marketplace from feed to search"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "A seller will have a label in his shop to see the account approval status")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "attribute-enhancement",
        nextElement: {
            "type": "paragraph"
        }
    }, "Attribute Enhancement"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Every new attribute type is an opportunity for marketplace to increase user experience"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Now you can get file attachment on account level or listing level. This will help you to do activities from KYC process to simple file verification "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can make attribute as private or public. Use cases like private data you want to gather from accounts/storeowners ")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 85482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "2021Q1 Product Updates",
    description: "\nAs a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do.\xa0",
    date: "2021-04-25T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-04-25-april";
var tableOfContents = [
    {
        "title": "New DIY SuperAdmin release",
        "slug": "new-diy-super-admin-release",
        "children": []
    },
    {
        "title": "Old Process vs New SuperAdmin",
        "slug": "old-process-vs-new-super-admin",
        "children": [
            {
                "title": "What’s next?",
                "slug": "what-s-next",
                "children": []
            }
        ]
    },
    {
        "title": "New Community Forum",
        "slug": "new-community-forum",
        "children": []
    },
    {
        "title": "Private Support Portal",
        "slug": "private-support-portal",
        "children": []
    },
    {
        "title": "Core Platform Updates:",
        "slug": "core-platform-updates",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do. We are experimenting different things, reflecting on and making changes accordingly.  "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "2021Q1 ISN’T A REGULAR FOR US! ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "It’s been a wonderful quarter, We are able to move lot of things from manual to automated. Thanks to the team for their consistent energy making every dream a reality. They were able to do because of the patience and support from our customers. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "new-diy-super-admin-release",
        nextElement: {
            "type": "paragraph"
        }
    }, "New DIY SuperAdmin release"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Automation was one of our top 3 quarterly priorities. This is going to tremendously helpful to our customers.  You do not rely on with us for many small changes or even signing up a new sandbox account with us, we have got the fundamentals ready now. There is still lot of things to be done. However this is a good start that we are able to reach this point. This is something we envisioned. All of us are happy that it’s partially live. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Get ready for the SuperAdmin and expect a surprising bugs as well \uD83D\uDE01\uD83D\uDE01 because we are still in beta."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "How to access? Go to ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/signup"
    }), "https://tradly.app/signup"), " or superadmin.tradly.app with the same credentials you have before. Or signup a new account on the sandbox itself. (Not mobile responsive as of now)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://www.youtube.com/watch?v=AoU2Htf46ZI"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", Object.assign({
        parentName: "a"
    }, {
        "src": "/img/superadmin_v2.png",
        "alt": "superadmin_v2"
    })))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "old-process-vs-new-super-admin",
        nextElement: {
            "type": "paragraph"
        }
    }, "Old Process vs New SuperAdmin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", Object.assign({
        parentName: "p"
    }, {
        "src": "/img/superadmin_v2_difference.png",
        "alt": "superadmin_v2_difference"
    }))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "what-s-next",
        nextElement: {
            "type": "paragraph"
        }
    }, "What’s next?"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are only 15% of what we have planned. The next few weeks will receive regular updates "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Stabilising the beta release of the new SuperAdmin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Transferring the pending features from the old SuperAdmin(v1) to the New(v2)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Automation of build request from dashboard itself (This might take months though) ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "new-community-forum",
        nextElement: {
            "type": "paragraph"
        }
    }, "New Community Forum"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We have been carefully thought about connecting with our customers and community on private channel (Slack) vs Public Community (", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://community.tradly.app"
    }), "https://community.tradly.app"), "). We have gone ahead by launching the early version of our public community forum. Comparing with Private, Public contributes to one of our values being an open (platform). Now anybody can join in the platform, ask questions, help each other, discuss our roadmaps, etc. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "private-support-portal",
        nextElement: {
            "type": "paragraph"
        }
    }, "Private Support Portal"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Everything that is confidential, build request, feature request, bug submission for paid customers will be done through our Support System (Puffin). The customers are onboarded into Support Portal once they become paid customer. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Averagely more than 80% of the tickets per client we have received whether it’s bug or enhancements has been completed per client")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "core-platform-updates",
        nextElement: {
            "type": "paragraph"
        }
    }, "Core Platform Updates:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are sharing regular updates (even weekly) on what is released on API and mobile apps in our Changelog. So we will be continuing there. We are considering to move this to our community channel or our status management system to make sure our customers like you get updates on what is ready for them to activate. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://community.tradly.app/c/api-changelog/11"
    }), "https://community.tradly.app/c/api-changelog/11")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://community.tradly.app/c/product-updates/9"
    }), "https://community.tradly.app/c/product-updates/9")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 91654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "2021Q2 Product Updates",
    description: "\nAs a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do.\xa0",
    date: "2021-09-01T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-09-01-sept";
var tableOfContents = [
    {
        "title": "Focus on Headless API Product",
        "slug": "focus-on-headless-api-product",
        "children": [
            {
                "title": "Open Source App Kits",
                "slug": "open-source-app-kits",
                "children": []
            }
        ]
    },
    {
        "title": "Additional Service and Product Offering through marketplace ecosystem",
        "slug": "additional-service-and-product-offering-through-marketplace-ecosystem",
        "children": []
    },
    {
        "title": "New API Functionalities.",
        "slug": "new-api-functionalities",
        "children": [
            {
                "title": "In-app payments (Google and Apple)",
                "slug": "in-app-payments-google-and-apple",
                "children": []
            },
            {
                "title": "Listing variance",
                "slug": "listing-variance",
                "children": []
            },
            {
                "title": "New payment gateways for the Middle East Countries",
                "slug": "new-payment-gateways-for-the-middle-east-countries",
                "children": []
            },
            {
                "title": "Search & filter improvements across the app (Especially attribute searches)",
                "slug": "search-and-filter-improvements-across-the-app-especially-attribute-searches",
                "children": []
            },
            {
                "title": "Map View for listing browsing",
                "slug": "map-view-for-listing-browsing",
                "children": []
            }
        ]
    },
    {
        "title": "Enhancement in SuperAdmin",
        "slug": "enhancement-in-super-admin",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We have been continuously finding ways to improve the product and customer expectations. With change always in mind, we have got the below updates to be shared. If you have got any feedback, share it with us."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We would like to share what we will be focusing on in the new few months and product updates."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Additional focus on Headless API Product"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Introducing Marketplace Ecosystem"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Product Updates")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "focus-on-headless-api-product",
        nextElement: {
            "type": "paragraph"
        }
    }, "Focus on Headless API Product"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "API first product is the core pillar of our solution offering. Increasing the focus and allocating more resources to API products will make"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "New product features "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Easy for partners(developers/agencies) to build applications (Action items like an enhancement to documentation and API Reference) "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Open-source front end starter kits to speed up the development of apps ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "open-source-app-kits",
        nextElement: {
            "type": "paragraph"
        }
    }, "Open Source App Kits"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "To speed up the development of front-end apps for the Headless product, we will be releasing new starter kits. We have developed three front-end (apps) starter kits. Few are already open-sourced and others will be available soon. These apps are built on top of Tradly API. If you are a developer, We welcome your feedbacks."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "1.", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, " ReactJs Web template"), "\nUse Cases: Product Marketplaces\nStatus of development: Intermediate\nGitHub Link ( ⭐️  it and watch for updates)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "2. React Native"), "\nUse Case: Event Marketplaces, Service Marketplaces which involve calendaring system\nStatus of development: Advanced\nGithub: Yet to be open-sourced (in a week or so) "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "3. React Native"), "\nUse cases: Recycle management, finding bins, collection point, etc\nStatus of development: Basic\nGithub: Available within this September"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "4. Flutter App"), "\nUse cases: Buyer-focused app for B2C brands /Grocery Shopping, etc.\nStatus of development: Basic\nGithub Link (⭐️ it and watch for updates)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "additional-service-and-product-offering-through-marketplace-ecosystem",
        nextElement: {
            "type": "paragraph"
        }
    }, "Additional Service and Product Offering through marketplace ecosystem"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Now you can own the Mobile Application Code"), " "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "PS: Not to confuse with the headless API / Backend source code"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "There are cases where you want to change the way the app looks or user experience. But don’t want to develop from scratch to avoid risks and time."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can buy the code directly in our marketplace. The Marketplace will have own code and partner codes as well. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Inviting Partner Development Agencies")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "We will be inviting new front-end development agencies to help with your custom app developments. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "They will be progressively onboarded in the coming months."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Do reach out to us if you are a developer or agencies wants to develop an application and sell it to our customers. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Advanced integrations as extensions ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Extensions/addons is advanced integrations and unique functionalities for different types of marketplaces "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "We have 20+  as of now from partner development agencies and in-house. We will be continuing to add more add-ons + providing suggestions to partner development agencies on what they can develop for you. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Feature updates "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "new-api-functionalities",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "New API Functionalities."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "in-app-payments-google-and-apple",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "In-app payments (Google and Apple)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "listing-variance",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Listing variance"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "new-payment-gateways-for-the-middle-east-countries",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "New payment gateways for the Middle East Countries"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "search-and-filter-improvements-across-the-app-especially-attribute-searches",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Search & filter improvements across the app (Especially attribute searches)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "map-view-for-listing-browsing",
        nextElement: {
            "type": "paragraph"
        }
    }, "Map View for listing browsing"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Plus dozen of minor improvements. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "enhancement-in-super-admin",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Enhancement in SuperAdmin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Email templates customization from SuperAdmin  (System emails going out can be customized) ")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 70761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: " 2021Q3 Product Updates",
    description: "Introducing Tradly JS SDK. We are super excited to bring this to you! ",
    date: "2021-11-07T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-11-07-nov";
var tableOfContents = [
    {
        "title": "NextJs + Tailwind Starter Kit",
        "slug": "next-js-tailwind-starter-kit",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Introducing Tradly JS SDK. We are super excited to bring this to you!\n", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://www.npmjs.com/package/tradly"
    }), "https://www.npmjs.com/package/tradly")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "What’s more than a SDK that can SAVE developers time to integrate new solution!\nStripe was a big inspiration for us. Making things easier for even a junior developers to build application faster was a goal to improve developer experience. And we did it. We are excited than ever in our journey to share our Javascript SDK is ready! "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "In addition to this SDK, all our existing open source code will be updated with this SDK on coming weeks. Hence it’s going to be easier for developers to apply customisation with a CONFIDENCE that always the SDK has the updated APIs and it’s feature set. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "To show you the power of the SDK, we launched another open source kits built on #nextjs & #Tailwind (Honourable mention that Tailwind has saved 40% our front end developers time) with SDK & deployed on @vercel"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "A headless API already saves a lot of time to launch #marketplace and #commerce apps. Adding a JS SDK means even faster development of front end apps. Launch omnichannel commerce apps with your favourite #JAMstack now. To see the demo of the starter kit build with SDK > ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://watchtracker.vercel.app/"
    }), "https://watchtracker.vercel.app/")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Or start fresh "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Register for a FREE ACCOUNT account and get the api key ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/signup"
    }), "https://tradly.app/signup")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Fork the repository ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://github.com/TRADLY-PLATFORM/Butterflies"
    }), "https://github.com/TRADLY-PLATFORM/Butterflies")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Deploy on #vercel, #Clouflare or #Netlify for free to see the demo.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "This mark an important milestone in our product releases. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "NEW: Tailwind CSS saving 40% of your front end developer time"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "NEW: Jamstack focused deployment tools make it easier than ever to launch apps. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "NEW: NextJS is a revolutionary framework to build static+dynamic together website. SEO benefits. Our design elements are componentized properly with deep thought process. So you can make changes easily. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "New SDK means saving your time to avoid API connection mistakes.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Our next goal:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Increase the performance of the starter kit and reaching GREEN on lighthouse performance benchmark. So your website loads faster."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Adding seller related features in the starter kit "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Releasing few more layouts that suit to different business nature.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "next-js-tailwind-starter-kit",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "NextJs + Tailwind Starter Kit"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Github Link: ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://github.com/TRADLY-PLATFORM/Butterflies"
    }), "https://github.com/TRADLY-PLATFORM/Butterflies")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Suitable to use as it is for event marketplace"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Deployment information in Github readme files")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: " Welcome",
    description: "We are pleased to announce our Tradly Platform knowledge portal which includes everything from documentation to detailed recipes on how to build a platform business. ",
    date: "2020-07-15T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-07-15-welcome";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are pleased to announce our Tradly Platform knowledge portal which includes everything from documentation to detailed recipes on how to build a platform business. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are starting small with information what we believe is needed for customers to start ahead. However, we will be regularly every week updating the contents to reflect new product updates and contents for our customers to be updated on what we are upto. "));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 34699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: " August Product Updates",
    description: "Thanks for being a great support to us and early adopters to help the product. \nYour ideas, your dreams and our vision are what drive us to innovate more and deliver new features.  ",
    date: "2020-09-12T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-09-12-augustupdate";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Hello All,"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Thanks for being a great support to us and early adopters to help the product.\nYour ideas, your dreams and our vision are what drive us to innovate more and deliver new features. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We are sharing here what’s happening recently.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Managing revenue model from SuperAdmin Panel"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", {
        parentName: "p"
    }), "\n", "We have released a commission model configuration which allows platform owners to set commission on product category level. Previously, it was available on overall transactions. ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/docs/revenuemodel",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "Further info")))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "New Notification center"), " ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", null), "\nAdding to our existing chat notifications, now you can find the permanent notification on the notification center about the order status and social feed.  ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Improved order detail page")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({
        parentName: "li"
    }, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Your buyers can directly chat with the seller.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Able to change the order status and confirm order delivery.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "And find the order status in detailed steps.\xa0"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Reviews")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({
        parentName: "li"
    }, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Your buyers can submit reviews with photos and ratings."))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "Other things")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({
        parentName: "li"
    }, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Design Kit: We have made our design kit open for our customers to test different thematic colors and UI customisation. Available ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/docs/appcustomisation#app-primary-color",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "here"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Updated our docs on the customisation to explain clearly what you can change and what you cannot\xa0before launching the app to Playstore and Appstore. Also their specifications of assets")))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "li"
    }, "Star ⭐️ of the month"), " ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", null), "\nOur customer from Australia wanted to connect plant \uD83C\uDF31 loving communities. They are launching a marketplace using our infrastructure to allow people to buy and sell plants. We are excited about their idea and doing our best to succeed in their business.\xa0Posting here the app link in our next update for you to check if you are from australia. ")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 61035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "September Update",
    description: "As always thanks for the support and for sharing about our product to others. We are doing great and we believe you as well \uD83D\uDE0A.\xa0",
    date: "2020-10-14T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-10-14-productupdate";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As always thanks for the support and for sharing about our product to others. We are doing great and we believe you as well \uD83D\uDE0A.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Tradly made it to the semi finals in a pitch battle \uD83C\uDFC5. The great thing is our very fitch pitch is to one of the best VC in the world, Sequoia Capital \uD83D\uDE0E."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Features updates"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "New YouTube channel with multiple demo of our products"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "New Pricing for developer community with our API focused headless solution"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Open sourcing our react web app, Hummingbird")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 15268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "2020Q4 Product Updates",
    description: "Listening to wonderful entrepreneurs out is one of the happiest moment we have every day. We listen to their feedbacks, their plans, doubts, etc. We are working towards solving each goal aggressively \uD83D\uDE0E\xa0",
    date: "2020-12-01T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2020-12-01-productupdate";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Listening to wonderful entrepreneurs out is one of the happiest moment we have every day. We listen to their feedbacks, their plans, doubts, etc. We are working towards solving each goal aggressively \uD83D\uDE0E"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "\xa0\nThe last quarter of 2020 was a promising one which gave us signal on what’s working, what’s not and what need to be enhanced as well. This is achieved through two level of performance tracking. We improved our sentry implementation to identify different logs in front end apps and same way identifying issues in our backend API/database performance. Other than that dozen of feature releases to activate!\xa0"));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "January Product Updates",
    description: "\nThanks for being great support to us with patience and feedbacks to improve the ecosystem. Every suggestions you give us always help your fellow entreprenuers as well.\xa0",
    date: "2021-01-18T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-01-18-january";
var tableOfContents = [
    {
        "title": "Account Approval",
        "slug": "account-approval",
        "children": []
    },
    {
        "title": "Attribute Enhancement",
        "slug": "attribute-enhancement",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Thanks for being great support to us with patience and feedbacks to improve the ecosystem. Every suggestions you give us always help your fellow entreprenuers as well. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Here is update for January so far:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Attributes enhancement (public-private, file attachment attribute)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Account Approval is live on production")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Note: If you want to activate this feature, let us know on slack for now. We will add this into SuperAdmin settings soon. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "account-approval",
        nextElement: {
            "type": "paragraph"
        }
    }, "Account Approval"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As a marketplace operators, you will be able to do a KYC process before approving stores to be shown in the marketplace. A bigger marketplace wants to regulate everything happening in it’s business"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Marketplace owner able to approve a store in superadmin panel similar to our existing listing approval"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can activate auto approval or manual approval based on your performance"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Until the store is activated, a seller account will not be visible in the marketplace from feed to search"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "A seller will have a label in his shop to see the account approval status")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "attribute-enhancement",
        nextElement: {
            "type": "paragraph"
        }
    }, "Attribute Enhancement"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Every new attribute type is an opportunity for marketplace to increase user experience"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Now you can get file attachment on account level or listing level. This will help you to do activities from KYC process to simple file verification "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can make attribute as private or public. Use cases like private data you want to gather from accounts/storeowners ")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 65243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "2021Q1 Product Updates",
    description: "\nAs a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do.\xa0",
    date: "2021-04-25T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-04-25-april";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "As a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do. We are experimenting different things, reflecting on and making changes accordingly.  "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "2021Q1 ISN’T A REGULAR FOR US! ")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 38071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: "2021Q2 Product Updates",
    description: "\nAs a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do.\xa0",
    date: "2021-09-01T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-09-01-sept";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We have been continuously finding ways to improve the product and customer expectations. With change always in mind, we have got the below updates to be shared. If you have got any feedback, share it with us."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "We would like to share what we will be focusing on in the new few months and product updates."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Additional focus on Headless API Product"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Introducing Marketplace Ecosystem"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Product Updates")));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 27832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; },
/* harmony export */   "meta": function() { return /* binding */ meta; },
/* harmony export */   "slug": function() { return /* binding */ slug; },
/* harmony export */   "tableOfContents": function() { return /* binding */ tableOfContents; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _authors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75270);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {
    title: " 2021Q3 Product Updates",
    description: "Introducing Tradly JS SDK. We are super excited to bring this to you! ",
    date: "2021-11-07T15:43:02.988Z",
    authors: [
        _authors__WEBPACK_IMPORTED_MODULE_4__.jk
    ]
};
var slug = "2021-11-07-nov";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Introducing Tradly JS SDK. We are super excited to bring this to you!\n", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://www.npmjs.com/package/tradly"
    }), "https://www.npmjs.com/package/tradly")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "What’s more than a SDK that can SAVE developers time to integrate new solution!\nStripe was a big inspiration for us. Making things easier for even a junior developers to build application faster was a goal to improve developer experience. And we did it. We are excited than ever in our journey to share our Javascript SDK is ready! "));
}
MDXContent.isMDXComponent = true;


/***/ }),

/***/ 75270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jk": function() { return /* binding */ authors_jk; }
});

;// CONCATENATED MODULE: ./src/img/authors/jk.jpeg
/* harmony default export */ var jk = ("/_next/static/media/jk.9735e5faa0aebcf40e6155abebac86ab.jpeg");
;// CONCATENATED MODULE: ./src/authors.js

var authors_jk = {
    name: "JK Baseer",
    twitter: "jkbaseer",
    avatar: jk
};


/***/ }),

/***/ 46675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);






var colors = {
    indigo: [
        "bg-indigo-50 text-indigo-600 hover:bg-indigo-200 hover:text-indigo-700 focus:ring-indigo-500",
        "text-indigo-300 group-hover:text-indigo-400", 
    ],
    pink: [
        "bg-pink-50 text-pink-600 hover:bg-pink-100 hover:text-pink-700 focus:ring-pink-600",
        "text-pink-300 group-hover:text-pink-400", 
    ],
    sky: [
        "bg-sky-50 text-sky-600 hover:bg-sky-100 hover:text-sky-700 focus:ring-sky-600",
        "text-sky-300 group-hover:text-sky-400", 
    ],
    blue: [
        "bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 focus:ring-blue-600",
        "text-blue-300 group-hover:text-blue-400", 
    ],
    gray: [
        "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:ring-gray-500",
        "text-gray-300 group-hover:text-gray-400", 
    ]
};
function Button(_param) {
    var _color = _param.color, color = _color === void 0 ? "gray" : _color, href = _param.href, children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, _reverse = _param.reverse, reverse = _reverse === void 0 ? false : _reverse, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "color",
        "href",
        "children",
        "className",
        "reverse"
    ]);
    var colorClasses = typeof color === "string" ? colors[color] : color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("group inline-flex items-center h-9 rounded-full text-sm font-semibold whitespace-nowrap px-3 focus:outline-none focus:ring-2", colorClasses[0], className, reverse && "flex-row-reverse")
        }, props), {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("overflow-visible", reverse ? "mr-3" : "ml-3", colorClasses[1]),
                    width: "3",
                    height: "6",
                    viewBox: "0 0 3 6",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: reverse ? "M3 0L0 3L3 6" : "M0 0L3 3L0 6"
                    })
                })
            ]
        }))
    });
}


/***/ }),

/***/ 17782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var tinytime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4431);
/* harmony import */ var tinytime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tinytime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46675);





var postDateTemplate = tinytime__WEBPACK_IMPORTED_MODULE_2___default()("{MMMM} {DD}, {YYYY}");
function PostItem(param) {
    var title = param.title, category = param.category, slug = param.slug, date = param.date, children = param.children, _wide = param.wide, wide = _wide === void 0 ? false : _wide;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative flex flex-col", {
            "max-w-3xl lg:ml-auto xl:max-w-none xl:w-[50rem]": wide,
            "pt-8": category
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "mb-4 text-xl text-gray-900 tracking-tight font-bold",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/blog/".concat(slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-6 prose",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-auto flex flex-row-reverse items-center justify-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                        children: [
                            category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                        className: "sr-only",
                                        children: "Category"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                        className: "absolute top-0 left-0 text-sm leading-6 font-semibold text-cyan-500",
                                        children: category
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                className: "sr-only",
                                children: "Date"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("text-sm leading-6", {
                                    "lg:absolute lg:top-0 lg:right-full lg:mr-8 lg:whitespace-nowrap": wide
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                    dateTime: date,
                                    children: postDateTemplate.render(new Date(date))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "2",
                        height: "2",
                        fill: "currentColor",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("mx-4 text-gray-700", {
                            "lg:hidden": wide
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "1",
                            cy: "1",
                            r: "1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        href: "/blog/".concat(slug),
                        children: [
                            "Read more",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "sr-only",
                                children: [
                                    ", ",
                                    title
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 11869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GN": function() { return /* binding */ getAllPostPreviews; }
/* harmony export */ });
/* unused harmony exports getAll_PostPreviews, getAllPosts */
function importAll(r) {
    return r.keys().filter(function(filename) {
        return filename.startsWith(".");
    }).map(function(filename) {
        return {
            slug: filename.substr(2).replace(/\/index\.mdx$/, ""),
            filename: filename,
            module: r(filename)
        };
    }).filter(function(param) {
        var slug = param.slug;
        return !slug.includes("/snippets/");
    }).filter(function(p) {
        var ref, ref1;
        return (p === null || p === void 0 ? void 0 : (ref = p.module) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.private) !== true;
    }).sort(function(a, b) {
        var ref, ref1, ref2, ref3;
        return dateSortDesc(a === null || a === void 0 ? void 0 : (ref = a.module) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.date, b === null || b === void 0 ? void 0 : (ref2 = b.module) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.meta) === null || ref3 === void 0 ? void 0 : ref3.date);
    });
}
function dateSortDesc(a, b) {
    if (a > b) return -1;
    if (a < b) return 1;
    return 0;
}
function getAllPostPreviews() {
    return importAll(__webpack_require__(93467));
}
function getAll_PostPreviews() {
    return importAll(__webpack_require__(66756));
}
function getAllPosts() {
    return importAll(__webpack_require__(35316));
}


/***/ }),

/***/ 4431:
/***/ (function(module) {

"use strict";


//      

/**
 * We want to represent each subs. type as minimally as possible,
 * so instead of using strings we just use characters, which lets us
 * represent 27 individual subs. using a single character each.
 */

var UserText = 'a';
var FullMonth = 'b';
var PartialMonth = 'c';
var FullYear = 'd';
var PartialYear = 'e';
var DayOfTheWeek = 'f';
var Hour = 'g';
var Minutes = 'h';
var Seconds = 'i';
var PostOrAnteMeridiem = 'j';
var Day = 'k';
var DayOfTheMonth = 'l';
var NumberMonth = 'n';
var Hour24 = 'm';

var SubToTypeIdentifierMap = {
  'MMMM': FullMonth,
  'MM': PartialMonth,
  'Mo': NumberMonth,
  'YYYY': FullYear,
  'YY': PartialYear,
  'dddd': DayOfTheWeek,
  'DD': DayOfTheMonth,
  'Do': Day,
  'h': Hour,
  'H': Hour24,
  'mm': Minutes,
  'ss': Seconds,
  'a': PostOrAnteMeridiem
};

//      

/**
 * These types help ensure we don't misspell them anywhere. They will be
 * removed during build.
 */

var months = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

/**
 * Takes an integer and returns a string left padded with
 * a zero to the left. Used to display minutes and hours (1:01:00PM);
 */
function paddWithZeros(int) {
  return int < 10 ? '0' + int : '' + int;
}

/**
 * Adds suffix to day, so 16 becomes 16th.
 */
function suffix(int) {
  return int % 10 == 1 && int != 11 ? int + "st" : int % 10 == 2 && int != 12 ? int + "nd" : int % 10 == 3 && int != 13 ? int + "rd" : int + "th";
}

/**
 * The compiler takes in our array of tokens returned from the parser
 * and returns the formed template. It just iterates over the tokens and
 * appends some text to the returned string depending on the type of token.
 * @param {Array<Tokens>} tokens
 * @param {Date} date
 * @param {TinyTimeOptions} options
 * @returns {String}
 */
function compiler(tokens, date, options) {
  var month = date.getMonth();
  var year = date.getFullYear();
  var hours = date.getHours();
  var seconds = date.getSeconds();
  var minutes = date.getMinutes();
  var day = date.getDate();
  var compiled = '';
  var index = 0;
  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.t) {
      case UserText:
        // $FlowFixMe flow doesn't know that v is always populated on UserText
        compiled += token.v;
        break;
      case Day:
        compiled += suffix(day);
        break;
      case PartialMonth:
        compiled += months[month].slice(0, 3);
        break;
      case FullMonth:
        compiled += months[month];
        break;
      case NumberMonth:
        var mnth = month + 1;
        if (options.padMonth) {
          mnth = paddWithZeros(mnth);
        }
        compiled += mnth;
        break;
      case FullYear:
        compiled += year;
        break;
      case PartialYear:
        compiled += (year + '').slice(2);
        break;
      case DayOfTheWeek:
        compiled += days[date.getDay()];
        break;
      case DayOfTheMonth:
        compiled += options.padDays ? paddWithZeros(day) : day;
        break;
      case Hour:
        var hour = hours === 0 || hours === 12 ? 12 : hours % 12;
        if (options.padHours) {
          hour = paddWithZeros(hour);
        }
        compiled += hour;
        break;
      case Hour24:
        var hour24 = hours;
        if (options.padHours) {
          hour24 = paddWithZeros(hour24);
        }
        compiled += hour24;
        break;
      case Minutes:
        compiled += paddWithZeros(minutes);
        break;
      case Seconds:
        compiled += paddWithZeros(seconds);
        break;
      case PostOrAnteMeridiem:
        compiled += hours >= 12 ? 'PM' : 'AM';
        break;
    }
    index++;
  }
  return compiled;
}

//      
/**
 * t is type and v is value. Minified property
 * names are being used because the current minification
 * step does not mangle property names, and we want to
 * reduce bundle size as much as possible.
 */

/**
 * Rather than using a bunch of potentially confusing regular
 * expressions to match patterns in templates, we use a simple
 * parser, taking the aproach of a compiler. This is equivalent
 * to a lexer as it returns a stream of tokens. Since there is
 * no additional analysis required for semantics we just call
 * it a parser.
 * 
 * It will return an array of tokens, each corresponding to either
 * UserText (just text we want to render) or any number of the
 * subsitution types stored in SubToTypeIdentifierMap.
 * 
 */
function parser(template) {
  var tokens = [];
  /**
   * We iterate through each character in the template string, and track
   * the index of the character we're processing with `position`. We start
   * at 0, the first character.
   */
  var position = 0;
  /**
   * `text` is used to accumulate what we call "UserText", or simply text that
   * is not a subsitution. For example, in the template:
   *  
   *  "The day is {day}."
   * 
   * There are two instances of `UserText`, "The day is " and ".", which is the text
   * befor eand after the subsitution. With this template our tokens would look something like:
   * 
   * [
   *  { type: UserText, value: "The day is "},
   *  { type : DaySub },
   *  { type: UserText, value: "." }
   * ]
   * 
   */
  var text = '';
  while (position < template.length) {
    var char = template[position++];
    /**
     * A bracket indicates we're starting a subsitution. Any characters after this,
     * and before the next '}' will be considered part of the subsitution name.
     */
    if (char === '{') {
      // Push any `UserText` we've accumulated and reset the `text` variable.
      if (text) {
        tokens.push({
          t: UserText,
          v: text
        });
      }
      text = '';
      var sub = '';
      char = template[position++];
      while (char !== '}') {
        sub += char;
        char = template[position++];
      }
      tokens.push({
        t: SubToTypeIdentifierMap[sub]
      });
    }
    // Anything not inside brackets is just plain text.
    else {
        text += char;
      }
  }
  /**
   * We might have some text after we're done iterating through the template if
   * the template ends with some `UserText`.
   */
  if (text) {
    tokens.push({
      t: UserText,
      v: text
    });
  }
  return tokens;
}

//      
function tinytime(template) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var templateAST = parser(template);
  return {
    render: function render(date) {
      return compiler(templateAST, date, options);
    }
  };
}

module.exports = tinytime;
//# sourceMappingURL=tinytime.js.map


/***/ }),

/***/ 93467:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./2020-07-15-welcome/index.mdx": 46895,
	"./2020-09-12-augustupdate/index.mdx": 34699,
	"./2020-10-14-productupdate/index.mdx": 61035,
	"./2020-12-01-productupdate/index.mdx": 15268,
	"./2021-01-18-january/index.mdx": 355,
	"./2021-04-25-april/index.mdx": 65243,
	"./2021-09-01-sept/index.mdx": 38071,
	"./2021-11-07-nov/index.mdx": 27832,
	"src/pages/blog/2020-07-15-welcome/index.mdx": 46895,
	"src/pages/blog/2020-09-12-augustupdate/index.mdx": 34699,
	"src/pages/blog/2020-10-14-productupdate/index.mdx": 61035,
	"src/pages/blog/2020-12-01-productupdate/index.mdx": 15268,
	"src/pages/blog/2021-01-18-january/index.mdx": 355,
	"src/pages/blog/2021-04-25-april/index.mdx": 65243,
	"src/pages/blog/2021-09-01-sept/index.mdx": 38071,
	"src/pages/blog/2021-11-07-nov/index.mdx": 27832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93467;

/***/ }),

/***/ 35316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./2020-07-15-welcome/index.mdx": 28946,
	"./2020-09-12-augustupdate/index.mdx": 29591,
	"./2020-10-14-productupdate/index.mdx": 70107,
	"./2020-12-01-productupdate/index.mdx": 91899,
	"./2021-01-18-january/index.mdx": 24009,
	"./2021-04-25-april/index.mdx": 85482,
	"./2021-09-01-sept/index.mdx": 91654,
	"./2021-11-07-nov/index.mdx": 70761,
	"src/pages/blog/2020-07-15-welcome/index.mdx": 28946,
	"src/pages/blog/2020-09-12-augustupdate/index.mdx": 29591,
	"src/pages/blog/2020-10-14-productupdate/index.mdx": 70107,
	"src/pages/blog/2020-12-01-productupdate/index.mdx": 91899,
	"src/pages/blog/2021-01-18-january/index.mdx": 24009,
	"src/pages/blog/2021-04-25-april/index.mdx": 85482,
	"src/pages/blog/2021-09-01-sept/index.mdx": 91654,
	"src/pages/blog/2021-11-07-nov/index.mdx": 70761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35316;

/***/ }),

/***/ 66756:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 66756;
module.exports = webpackEmptyContext;

/***/ })

}]);